'use client'
import React from 'react'
import { classifyComposerPreview, composerPreviewBadgeFromClass, QL7_COMPOSER_PREVIEW_DEBOUNCE_MS, resolveComposerPreviewUpdate } from '../../../../../lib/composer-safety/clientPreview.js'

function withBadge(row = {}, source = '') {
  const badge = composerPreviewBadgeFromClass(row?.classId)
  return badge ? { ...row, ...badge, ...(source ? { source } : {}) } : { ...row, ...(source ? { source } : {}) }
}

export default function useComposerSafetyPreview(text='', { enabled=true, locale='und', targeted=false } = {}) {
  const [state,setState]=React.useState(null)
  React.useEffect(()=>{
    if(!enabled){setState(null);return undefined}
    const value=String(text||'')
    if(!value.trim()){setState(null);return undefined}
    let worker=null
    let aborted=false
    const commit=(row,source)=>{
      if(aborted)return
      const candidate=withBadge(row,source)
      // This result is final for the current input value. Server authority is
      // intentionally reserved for the actual submit routes.
      setState(previous=>resolveComposerPreviewUpdate(previous,candidate,{authoritative:true}))
    }
    const localTimer=setTimeout(()=>{
      try {
        if(typeof Worker==='function') worker=new Worker(new URL('../../../../../lib/composer-safety/previewWorker.js', import.meta.url),{type:'module'})
      } catch { worker=null }
      if(!worker){
        commit(classifyComposerPreview(value,{locale,targeted}),'client_preview_fallback');return
      }
      const done=(row)=>{commit(row,row?.source||'client_preview_worker');try{worker.terminate()}catch{} }
      worker.onmessage=(event)=>done(event.data||{})
      worker.onerror=()=>done({...classifyComposerPreview(value,{locale,targeted}),source:'client_preview_fallback'})
      worker.postMessage({text:value,locale,targeted})
    },Math.max(320,QL7_COMPOSER_PREVIEW_DEBOUNCE_MS-100))

    return()=>{aborted=true;clearTimeout(localTimer);try{worker?.terminate()}catch{}}
  },[text,enabled,locale,targeted])
  return state
}
